import { useQuery } from '@tanstack/react-query';
import { trpc } from '@/utils/trpc';
import type { SearchAnonymousRecordFaxesInput } from '../types';

export const useSearchAnonymousRecordFaxes = (
  input: SearchAnonymousRecordFaxesInput,
  options?: { enabled?: boolean },
) =>
  useQuery({
    ...trpc.recordUploadRouter.searchAnonymousRecordFaxes.queryOptions(input),
    enabled: options?.enabled ?? true,
  });
